module.exports = __webpack_public_path__ + "bda8a9396ac0e5020e8c8b2d179dfc88.png";